var React = require('react')
const PropTypes = React.PropTypes; //TODO: react 15.5 -> require( 'prop-types' );

export class ClickOutside extends React.Component {
    constructor() {
        super()

        this._handle = this.handle.bind(this)
    }

    render() {
        const { children, onClickOutside, ...props } = this.props
        return <div {...props} ref={ref => this.container = ref}>{children}</div>
    }

    componentDidMount() {
        //using jquery for IE8 compat, remove after deprecation
        //document.addEventListener('click', this._handle, true)
        $(document).on('click', this._handle)
    }

    componentWillUnmount() {
        //using jquery for IE8 compat, remove after deprecation
        //document.removeEventListener('click', this._handle, true)
        $(document).off('click', this._handle)
    }

    handle(e)  {
        const { onClickOutside } = this.props
        const el = this.container

        if (!el.contains(e.target)) onClickOutside(e)
    }
}

ClickOutside.propTypes = {
    onClickOutside: PropTypes.func.isRequired
}

export function clickoutsideWrapper(Component, handler) {
    return (
        <ClickOutside onClickOutside={handler}>
            {Component}
        </ClickOutside>
    )
}


// WEBPACK FOOTER //
// ./js/caseconfigurator/components/UI/ClickOutside.jsx